// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"02bee4e8","114":"beada263"}[chunkId] + ".chunk.css";
};